import { css, cx } from '@bts-web/utils-style-engine';
import { ReactNode } from 'react';

const hiddenOnMobileStyles = css({
  display: { base: 'none', lg: 'flex' },
});

export const TradeBoxContainerInTradeWrapper = ({
  children,
  onClick,
  hideMobile,
  hideOnMobile,
  refProp,
}: {
  children: ReactNode;
  onClick: () => void;
  hideMobile: 'tradeElement' | 'assetElement';
  hideOnMobile?: boolean;
  refProp: React.RefObject<HTMLDivElement>;
}) => (
  <div
    ref={refProp}
    className={cx(
      css({
        zIndex: 6,
        width: '100%',
        position: {
          base: 'fixed',
          lg: 'sticky',
        },
        height: {
          base: '100dvh',
          lg: '100vh',
        },
        top: {
          lg: 'calc(var(--spacing-extra_small_4) + 72px + var(--layout-sticky-offset, 0px))',
        },
        maxHeight: {
          base: '100%',
          lg: 'calc(100vh - var(--spacing-extra_small_4) - 74px - var(--layout-sticky-offset, 0px))',
        },
        maxWidth: {
          base: hideMobile === 'assetElement' ? '100%' : '420px',
          lg: '420px',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }),
      hideOnMobile && hiddenOnMobileStyles,
    )}
    onClick={onClick}
    data-testid="trade-state-content"
  >
    <div
      className={css({
        bg: 'screen_background.primary',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '100%',
        borderInlineStartColor: 'neutrals.stroke_secondary',
        borderInlineStartWidth: '1px',
        borderStyle: 'solid',
        maxWidth: {
          base: '100%',
          lg: '420px',
        },
      })}
    >
      {children}
    </div>
  </div>
);
